var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pie-chart',{attrs:{"chart-data":_vm.chartData,"tooltips":false,"doughnut":true,"center-text":_vm.centerText,"display-legend":false,"cutout-percentage":90,"animate":_vm.animate}})}
var staticRenderFns = []

export { render, staticRenderFns }